<template>
  <div class="print-repair-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('printRepairDetail.page.title')" :subtitle="$t('printRepairDetail.page.subtitle')">
      <template #extra>
        <el-button type="primary" icon="el-icon-printer" @click="handlePrint">
          {{ $t('common.print') }}
        </el-button>
        <el-button icon="el-icon-close" @click="handleClose">
          {{ $t('common.cancel') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 报修单内容面板 -->
    <div class="ds-panel">
      <el-row :gutter="16" class="top-section">
        <el-col :span="8">
          <span>{{ $t('printRepairDetail.repairId') }}</span><span class="ds-num">{{ printRepairDetailInfo.repairId }}</span>
        </el-col>
        <el-col :span="8">
          <span></span>
        </el-col>
        <el-col :span="8">
          <span>{{ $t('printRepairDetail.printTime') }}</span><span class="ds-num">{{ nowTime }}</span>
        </el-col>
      </el-row>

      <table class="ds-print-table">
        <thead>
          <tr>
            <th colspan="6" class="text-center">{{ $t('printRepairDetail.repairInfo') }}</th>
          </tr>
          <tr>
            <th>{{ $t('printRepairDetail.repairName') }}</th>
            <th>{{ $t('printRepairDetail.tel') }}</th>
            <th>{{ $t('printRepairDetail.location') }}</th>
            <th>{{ $t('printRepairDetail.context') }}</th>
            <th v-if="printRepairDetailInfo.maintenanceType">{{ $t('printRepairDetail.maintenanceType') }}</th>
            <th v-if="printRepairDetailInfo.maintenanceType === '1001'">{{ $t('printRepairDetail.repairMaterials') }}</th>
            <th v-if="printRepairDetailInfo.maintenanceType === '1001'" colspan="3">{{ $t('printRepairDetail.repairFee') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ printRepairDetailInfo.repairName }}</td>
            <td>{{ printRepairDetailInfo.tel }}</td>
            <td>{{ printRepairDetailInfo.location }}</td>
            <td>{{ printRepairDetailInfo.context }}</td>
            <td v-if="printRepairDetailInfo.maintenanceType">{{ printRepairDetailInfo.maintenanceType }}</td>
            <td v-if="printRepairDetailInfo.maintenanceType === '1001'">{{ printRepairDetailInfo.repairMaterials }}</td>
            <td v-if="printRepairDetailInfo.maintenanceType === '1001'" colspan="3">{{ printRepairDetailInfo.repairFee }}</td>
          </tr>
        </tbody>
      </table>

      <table class="ds-print-table">
        <thead>
          <tr>
            <th colspan="6" class="text-center">{{ $t('printRepairDetail.workflow') }}</th>
          </tr>
          <tr>
            <th class="text-center">{{ $t('printRepairDetail.serialNumber') }}</th>
            <th class="text-center">{{ $t('printRepairDetail.handler') }}</th>
            <th class="text-center">{{ $t('printRepairDetail.status') }}</th>
            <th class="text-center">{{ $t('printRepairDetail.processTime') }}</th>
            <th class="text-center">{{ $t('printRepairDetail.timeConsuming') }}</th>
            <th class="text-center">{{ $t('printRepairDetail.comment') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in printRepairDetailInfo.repairUsers" :key="index">
            <td class="text-center ds-num">{{ index + 1 }}</td>
            <td class="text-center">{{ item.staffName }}</td>
            <td class="text-center">{{ item.stateName }}</td>
            <td class="text-center ds-num">{{ item.startTime }}</td>
            <td class="text-center ds-num">{{ item.duration }}</td>
            <td class="text-center">{{ item.context }}</td>
          </tr>
          <tr>
            <td colspan="6">{{ printRepairDetailInfo.description }}</td>
          </tr>
          <tr>
            <td colspan="2" class="sign-cell">{{ $t('printRepairDetail.repairerSign') }}</td>
            <td colspan="2" class="sign-cell">{{ $t('printRepairDetail.customerSign') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listOwnerRepairs, listRepairStaffs } from '@/api/work/printRepairDetailApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'PrintRepairDetailList',
  components: {
    DsPageHeader
  },
  data() {
    return {
      printRepairDetailInfo: {
        repairId: '',
        repairTypeName: '',
        appointmentTime: '',
        repairName: '',
        tel: '',
        repairObjName: '',
        context: '',
        repairUsers: [],
        maintenanceType: '',
        repairMaterials: '',
        repairFee: '',
        description: ''
      },
      printFlag: '0',
      nowTime: '',
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._initPrintRepairDetailDateInfo()
    const myDate = new Date()
    this.nowTime = myDate.toLocaleDateString()
  },
  methods: {
    _initPrintRepairDetailDateInfo() {
      const _repairId = this.$route.query.repairId
      const _repairType = this.$route.query.repairType
      const param = {
        page: 1,
        row: 1,
        repairId: _repairId,
        communityId: this.communityId,
        repairType: _repairType
      }

      listOwnerRepairs(param)
        .then(response => {
          const _repairDetailInfo = response.data[0]
          Object.assign(this.printRepairDetailInfo, _repairDetailInfo)
          this._loadRepairUser()
        })
        .catch(error => {
          console.error('请求失败处理:', error)
        })
    },
    _loadRepairUser() {
      const param = {
        page: 1,
        row: 100,
        communityId: this.communityId,
        repairId: this.printRepairDetailInfo.repairId
      }

      listRepairStaffs(param)
        .then(response => {
          this.printRepairDetailInfo.repairUsers = response.data
        })
        .catch(error => {
          console.error('请求失败处理:', error)
        })
    },
    handlePrint() {
      this.printFlag = '1'
      window.print()
      window.opener = null
      window.close()
    },
    handleClose() {
      window.opener = null
      window.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.print-repair-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 票据内容面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);
  padding: var(--ds-spacing-lg);
}

.top-section {
  margin-bottom: var(--ds-spacing-md);
}

.text-center {
  text-align: center;
}

.sign-cell {
  height: 60px;
  text-align: center;
}

/* 打印表格 */
.ds-print-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--ds-gray-300);
  background-color: #fff;
  margin-bottom: var(--ds-spacing-md);

  &:last-child {
    margin-bottom: 0;
  }

  th,
  td {
    padding: var(--ds-spacing-md) var(--ds-spacing-sm);
    border: 1px solid var(--ds-gray-300);
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-900);
  }

  th {
    background-color: var(--ds-gray-100);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

@media print {
  .ds-page-header {
    display: none !important;
  }

  .print-repair-detail-container {
    padding: 0;
    background: #fff;
  }

  .ds-panel {
    border: none;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
  }
}
</style>
